import items from './items';

/** Builds out the rows for the legend */
export default function(legendEnter, options, isDistribution = false) {
  const row = legendEnter.selectAll(
      (isDistribution)
      ? '.legend-row.legend-row-distribution'
      : '.legend-row.legend-row-item'
    )
    .data((d) => (isDistribution) ? d.distributions : d.states);

  const rowEnter = row.enter()
    .append('g')
    .classed({
      'legend-row': true,
      'legend-row-item': !isDistribution,
      'legend-row-distribution': isDistribution,
    });

  items(rowEnter, options, isDistribution);
  row.exit();
}



// WEBPACK FOOTER //
// ../datacenter/app/js/util/d3.legend/rows.js